import { Button, Carousel, Divider, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { common } from "../../services";
import { DefaultImg, KdMarker } from "../images";
import "./style.scss";
import { STORE_PAYMENT_METHOD } from "./../../common/constant";
import {
  ClockCircleOutlined,
  CreditCardOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const StoreMapDetailModal = (props: any) => {
  const { t } = useTranslation();
  const { id, isModalVisible, handleClose } = props;
  const [storeDetail, setStoreDetail] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [isGetted, setIsGetted] = useState(false);

  useEffect(() => {
    if (isModalVisible) getStoreDetail();
  }, [isModalVisible]);

  useEffect(() => {
    if (isModalVisible && isGetted) {
      initMap();
    }
  }, [isGetted]);

  const getStoreDetail = () => {
    setIsGetted(false);
    setLoading(true);
    common.getStore(id, (data, err) => {
      if (data) {
        setStoreDetail(data);
        setLoading(false);
        setIsGetted(true);
      }
    });
  };

  const initMap = () => {
    const map = new google.maps.Map(
      document.getElementById(`store-detail-address-${storeDetail._id}`),
      {
        zoom: 14,
        center: { lat: storeDetail.lat, lng: storeDetail.lng },
      }
    );

    const marker = new google.maps.Marker({
      position: { lat: storeDetail.lat, lng: storeDetail.lng },
      map: map,
      icon: {
        url: KdMarker,
        scaledSize: new google.maps.Size(24, 24), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(0, 0), // anchor
      },
    });
    const infoWindow = new google.maps.InfoWindow({
      content: storeDetail.name,
    });

    marker.addListener("click", () => {
      infoWindow.open(map, marker);
    });

    map.addListener("click", () => {
      infoWindow.close();
    });
  };

  return (
    <div>
      <Modal
        width={800}
        title={t("store_map_info_title")}
        visible={isModalVisible}
        onOk={handleClose}
        onCancel={handleClose}
        footer={[
          <Button type="primary" onClick={handleClose}>
            {t("close")}
          </Button>,
        ]}>
        {isModalVisible &&
          (loading ? (
            <Spin />
          ) : (
            storeDetail && (
              <div>
                <div className="store-img-name-container">
                  <Carousel autoplay className="img-detail" dots={false}>
                    {storeDetail.img_details.length ? (
                      storeDetail.img_details.map((item: any, index: any) => (
                        <img
                          className="img-detail-item"
                          key={index}
                          src={item}
                        />
                      ))
                    ) : (
                      <img className="img-detail-item" src={DefaultImg} />
                    )}
                  </Carousel>
                  <div className="store-name">
                    <span>{storeDetail.name}</span>
                  </div>
                </div>

                <div>
                  <div
                    id={`store-detail-address-${storeDetail._id}`}
                    className="store-info-item-address-map"></div>
                  <div className="store-info-item-container">
                    <i className="fas fa-map-marker-alt store-info-item-icon"></i>
                    <div className="store-info-item">
                      <span>
                        {storeDetail.address}
                        &nbsp;(
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${storeDetail.lat},${storeDetail.lng}`}
                          target="_blank">
                          Chỉ đường
                        </a>
                        )
                      </span>
                    </div>
                  </div>
                </div>

                <Divider orientation="left">{t("store_detail")}</Divider>
                <div>
                  <div className="store-info-item-container">
                    <ClockCircleOutlined className="store-info-item-icon" />
                    <div className="store-info-item">
                      <span>{t("store_open_hours")}</span>
                      <span>{storeDetail.open_hours}</span>
                    </div>
                  </div>
                  <div className="store-info-item-container">
                    <PhoneOutlined className="store-info-item-icon" />
                    <div className="store-info-item">
                      <span>{t("label_store_contact")}</span>
                      <span>{storeDetail.phone_number}</span>
                    </div>
                  </div>
                  <div className="store-info-item-container">
                    <CreditCardOutlined className="store-info-item-icon" />
                    <div className="store-info-item">
                      <span>{t("payment_method")}</span>
                      {STORE_PAYMENT_METHOD.map((item, index) => (
                        <span key={index}>
                          {storeDetail.payment_method.find(
                            (d: any) => d === item.value
                          ) ? (
                            <i className="fas fa-check-square"></i>
                          ) : (
                            <i className="far fa-square"></i>
                          )}
                          &nbsp;{t(item.label)}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )
          ))}
      </Modal>
    </div>
  );
};

export default StoreMapDetailModal;
